<template>
  <div ref="dropdown" :class="buttonWarpperClass">
    <!-- Dropdown Toggle Button -->
    <button :class="buttonClass" @click="toggleDropdown" :disabled="disabled">
      <span :class="buttonTextClass">{{ selectedLabel }}</span>

      <div :class="buttonIconClass">
        <img src="../../assets/images/create-quote-icon.png" />
      </div>

      <div :class="buttonDropdownIcon">
        <i class="fa fa-angle-down !text-[24px]"></i>
      </div>
    </button>

    <!-- Dropdown Menu -->
    <div v-if="isOpen" :class="dropdownListClass">
      <ul class="list-inline mb-0 p-0 max-h-60 overflow-y-auto">
        <li v-for="(item, index) in items" :key="index" :class="dropdownListLIClass">
          <a :class="dropdownListAnchorClass" @click="selectItem(item)">
            {{ item[labelKey] }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue", "select"],
  props: {
    modelValue: {
      type: [String, Number, Object],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    buttonWarpperClass: [String, Array, Object],
    buttonClass: [String, Array, Object],
    buttonIconClass: [String, Array, Object],
    buttonDropdownIcon: [String, Array, Object],
    buttonTextClass: [String, Array, Object],
    buttonText: String,
    dropdownListClass: [String, Array, Object],
    dropdownListLIClass: [String, Array, Object],
    dropdownListAnchorClass: [String, Array, Object],
    disabled: {
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.items.find((item) => {
        if (this.valueKey === "object") {
          return JSON.stringify(item) === JSON.stringify(this.modelValue);
        }
        return item[this.valueKey] === this.modelValue;
      });
      return selected ? selected[this.labelKey] : this.buttonText;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    selectItem(item) {
      const value = this.valueKey === "object" ? item : item[this.valueKey];
      this.$emit("update:modelValue", value);
      this.$emit("select", item);
      this.isOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>
